import { useQuery } from '@tanstack/react-query'
import { useAPIClient } from '@/hooks/useApi'
import type { PageWidgetKeyResponseDTO, WidgetKeyResponseDTO } from '@/api/generated/models'

// Use generated DTO as source of truth
export type WidgetKey = WidgetKeyResponseDTO

// Hook to fetch widget keys with pagination
export const useWidgetKeys = (limit: number = 100, offset: number = 0) => {
  const { widgetKeysApi } = useAPIClient()

  return useQuery<PageWidgetKeyResponseDTO>({
    queryKey: ['widget-keys', limit, offset],
    queryFn: async () => {
      const response = await widgetKeysApi.listWidgetKeysApiV1WidgetKeysGet(limit, offset)
      return response.data
    },
    staleTime: 10 * 60 * 1000, // Consider data fresh for 10 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
  })
}

// Hook to fetch a single widget key
export const useWidgetKey = (id: string | null) => {
  const { widgetKeysApi } = useAPIClient()

  return useQuery({
    queryKey: ['widget-keys', id],
    queryFn: async () => {
      const response = await widgetKeysApi.getWidgetKeyApiV1WidgetKeysWidgetKeyIdGet(id!)
      return response.data
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled: !!id, // Only run query if id is provided
  })
}
